import { Prisma } from "@prisma/client";
import { BuyableItemEvent, BuyableItemHandler } from "../buyable-item.types";

type PartialEventCustomAppearanceBuyableItem = {
  eventCustomAppearanceEvent?: { id: string } | null;
};

type EventCustomAppearanceBuyableItem = {
  eventCustomAppearanceEvent: { id: string };
};

type EventCustomAppearanceWithEvent = {
  eventCustomAppearanceEvent: BuyableItemEvent;
};

const GROUP_KEY_PREFIX = "eventCustomAppearance";

export const EventCustomAppearanceBuyableItemHandler = {
  displayName: "Personnalisation événement",
  isCumulative: false,
  accounting: {
    generalAccountCode: "706511",
    invoiceLabel: "Personnalisation événement",
  },

  getEvent(item: EventCustomAppearanceWithEvent): BuyableItemEvent {
    return item.eventCustomAppearanceEvent;
  },

  isValid(item: PartialEventCustomAppearanceBuyableItem): boolean {
    return !!item.eventCustomAppearanceEvent?.id;
  },

  findEquivalent(
    item: PartialEventCustomAppearanceBuyableItem,
  ): Prisma.BuyableItemWhereInput {
    return {
      eventCustomAppearanceEvent: {
        id: item.eventCustomAppearanceEvent?.id,
      },
    };
  },

  create({
    eventCustomAppearanceEvent,
  }: EventCustomAppearanceBuyableItem): Omit<Prisma.BuyableItemCreateInput, "buyableType"> {
    return {
      eventCustomAppearanceEvent: {
        connect: {
          id: eventCustomAppearanceEvent.id,
        },
      },
    };
  },

  parseGroupKeyAsWhere(groupKey: string): Prisma.BuyableItemWhereInput {
    if (!EventCustomAppearanceBuyableItemHandler.isGroupKey(groupKey)) {
      throw new Error(`Invalid group key for eventCustomAppearance: ${groupKey}`);
    }

    const [, eventId] = groupKey.split("|");
    return {
      eventCustomAppearanceEvent: {
        id: eventId,
      },
    };
  },

  isGroupKey(groupKey: string): boolean {
    return groupKey.startsWith(`${GROUP_KEY_PREFIX}|`);
  },

  getGroupKey(item: PartialEventCustomAppearanceBuyableItem): string {
    const eventId = item.eventCustomAppearanceEvent?.id;
    if (!eventId) {
      throw new Error("Cannot get group key for invalid eventCustomAppearance item");
    }
    return `${GROUP_KEY_PREFIX}|${eventId}`;
  },

  getPricingQuery(): Prisma.PricingFindFirstArgs {
    return {
      where: {
        backofficePrestation: {
          type: "eventCustomAppearance",
        },
      },
    };
  },

  getEventSearchFilter(searchText: string): Prisma.BuyableItemWhereInput {
    return {
      eventCustomAppearanceEvent: {
        name: { contains: searchText, mode: "insensitive" },
      },
    };
  },
} as const satisfies BuyableItemHandler;
